import { useQueryHook } from "@/hooks"
import { TEAM_SETTING_CACHE } from "@/hooks/api/queryCache"
import { readMetricList } from "@/app/api/metric"
import { createAccountStore } from "@/stores/account"

export const useMetricList = () => {
  const accessTestFeature = createAccountStore(
    (state) => state.teamProfileInfo?.teamPermissions?.ACCESS_TEST_FEATURE,
  )

  return useQueryHook({
    queryKey: ["readMetricList", !!accessTestFeature],
    options: TEAM_SETTING_CACHE,
    queryFn: async () => {
      const result = await readMetricList()
      return {
        ...result,
        response: Array.isArray(result.response)
          ? result.response.filter(
              (metric) =>
                metric.isReportMetric &&
                (accessTestFeature || !metric.key?.toUpperCase().includes("COD")),
            )
          : [],
      }
    },
  })
}
